// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"072f9797","159":"afd02650","360":"8dce73d5","438":"f6564159","471":"60eab17f","677":"14e4094c","952":"31d4ce60"}[chunkId] + ".chunk.js";
};